module.exports = __webpack_public_path__ + "media/images/icons/copy-886fc6f965cd9762c6ba09009fffb0c9.svg";